import {Button, Card, Divider, Tag, Typography} from "antd";
import {formatDateTime} from "@/helpers/dateFormatHelper.ts";
import {localizedNumberFormatter} from "@/helpers/numberFormatHelper.tsx";
import type {Raid} from "@/raids/rest/RaidSchema.ts";

type RaidInfoCardProps = {
  raid: Raid,
  openRaid?: (id: Raid['id']) => void
  joinRaid?: (id: Raid['id']) => void
};

export function RaidInfoCard({raid, openRaid, joinRaid}: RaidInfoCardProps) {
  return (
      <Card
          key={`raid-id-${raid.id}`}
          tabIndex={0}
          className={"focus-selected flex-1 cursor-pointer shadow-[var(--custom-box-shadow)] max-w-3xl duration-200 ease-in-out hover:-translate-y-0.5"}
          classNames={{
            header: "min-h-[32px]!"
          }}
          onClick={() => openRaid?.(raid.id)}
          title={
            <Typography.Paragraph className={"mb-0!"}>{raid.name}</Typography.Paragraph>
          }>
        <div className={"flex gap-2"}>
          <div className={"flex-1 flex flex-col gap-1 min-w-0"}>
            {raid.endTime && <Tag className={"whitespace-normal! shadow-[var(--custom-box-shadow)]"} color="volcano">Beendet
              am {formatDateTime(raid.endTime)}</Tag>}
            {raid.startTime && !raid.endTime &&
                <Tag className={"whitespace-normal! shadow-[var(--custom-box-shadow)]"} color="green">Laufend</Tag>}
            {!raid.startTime && !raid.endTime &&
                <Tag className={"whitespace-normal! shadow-[var(--custom-box-shadow)]"} color="gold">In Vorbereitung</Tag>}
            <Tag color="default">
              <div className={"flex-1 flex justify-between"}>
                <div>Teilnehmer:</div>
                <div>{localizedNumberFormatter(raid.participants.length)}</div>
              </div>
            </Tag>
          </div>
          <div className={"flex-1 flex flex-col gap-1 min-w-0"}>
            <Tag color="default">
              <div className={"flex-1 flex justify-between"}>
                <div>Spice:</div>
                <div>{localizedNumberFormatter(raid.spiceReadOnly)}</div>
              </div>
            </Tag>
            <Tag color="default">
              <div className={"flex-1 flex justify-between"}>
                <div>Titanium:</div>
                <div>{localizedNumberFormatter(raid.titaniumReadOnly)}</div>
              </div>
            </Tag>
            <Tag color="default">
              <div className={"flex-1 flex justify-between"}>
                <div>Stravidium:</div>
                <div>{localizedNumberFormatter(raid.stravidiumReadOnly)}</div>
              </div>
            </Tag>
          </div>
        </div>
        {joinRaid &&
            <>
              <Divider className={"mt-2! mb-2!"}/>
              <div className={"flex justify-center"}>
                <Button onClick={() => joinRaid(raid.id)}>Jetzt beitreten</Button>
              </div>
            </>
        }
      </Card>
  );
}